export default function QuestionComponent() {
  return (
    <div>
      <svg
        width="12px"
        height="20px"
        viewBox="0 0 12 20"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <title>工单问号</title>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            transform="translate(-363.000000, -398.000000)"
            fill="#007BFC"
            fillRule="nonzero"
          >
            <g transform="translate(348.000000, 387.000000)">
              <path d="M22.2648,25.2032 L22.2648,24.9832 C22.2648,23.7656 22.8632,22.6344 23.8536,21.9752 C25.8912,20.6192 27,19.0248 27,17.1864 C27,13.7696 24.3144,11 21,11 C17.6856,11 15,13.7696 15,17.1864 C15,17.9056 15.564,18.4904 16.2648,18.4904 C16.9616,18.4904 17.5288,17.9096 17.5288,17.1864 C17.5288,15.2072 19.084,13.604 21.004,13.604 C22.924,13.604 24.4784,15.2072 24.4784,17.1864 C24.4784,17.996 23.876,18.864 22.4896,19.7864 C20.7792,20.9256 19.7432,22.8824 19.7432,24.9832 L19.7432,25.2032 C19.7432,25.9224 20.3064,26.5072 21.004,26.5072 C21.6968,26.504 22.2608,25.9224 22.2648,25.2032 L22.2648,25.2032 Z M19.6,29.5712 C19.6,30.3616 20.2288,31 21,31 C21.7744,31 22.4,30.3584 22.4,29.572 C22.4,28.7816 21.7744,28.1432 21,28.14 C20.2256,28.14 19.6,28.7816 19.6,29.572 L19.6,29.5712 Z" />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
}
